import AuthorizationApi from "./api/server/authorization";

let authLocalCache = null;

var CheckIfUserIsAdmin = async function () {
  if (authLocalCache) {
    return authLocalCache;
  }

  var auth = await AuthorizationApi.auth();
  if (auth) {
    authLocalCache = auth.userrole == "Admin";
  }

  return authLocalCache;
}

export default CheckIfUserIsAdmin;
